import React, { useState, useRef } from 'react';
import { FaLink, FaDownload, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import QRCode from 'react-qr-code';
import './ShareProfileModal.css';
import { useLanguage } from '../../contexts/LanguageContext';

const ShareProfileModal = ({ onClose, profileUrl }) => {
  const [copied, setCopied] = useState(false);
  const qrCodeRef = useRef(null);
  const navigate = useNavigate();
  const { translations: t } = useLanguage();

  const handleCopyLink = () => {
    navigator.clipboard.writeText(profileUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDownloadQR = () => {
    const svg = qrCodeRef.current.querySelector('svg');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngUrl = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.href = pngUrl;
      downloadLink.download = 'iwinto-profile-qr.png';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };

    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
  };

  return (
    <div className="share-profile-modal-overlay">
      <div className="share-profile-modal">
        <button
          className="close-button"
          onClick={onClose}
          aria-label={t.close || "Close"}
          title={t.close || "Close"}
        >
          <FaTimes />
        </button>

        <h2>{t.shareMyProfile?.title || "Share My Profile"}</h2>

        <div className="qr-code-container" ref={qrCodeRef}>
          <QRCode
            value={profileUrl}
            size={200}
            bgColor="#ffffff"
            fgColor="#000000"
            level="H"
          />
          <p style={{ marginTop: '8px', fontSize: '12px', color: '#000000' }}>
            {t.shareMyProfile?.scanHint || "Scan to view profile"}
          </p>
        </div>

        <p className="profile-url">{profileUrl}</p>

        <div className="action-buttons">
          <button className="share-button" onClick={handleCopyLink}>
            <FaLink className="button-icon" />
            {copied ? (t.shareMyProfile?.copied || "Copied!") : (t.shareMyProfile?.copyLink || "Copy Link")}
          </button>

          <button className="download-button" onClick={handleDownloadQR}>
            <FaDownload className="button-icon" />
            {t.shareMyProfile?.saveQr || "Save QR"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareProfileModal;
